import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle
} from '@/components/ui/alert-dialog'

interface DeleteTargetDialogProps {
    isOpen: boolean
    onClose: () => void
    onDelete: () => void
    targetNumber?: string
    phoneNumber?: string
}

export function DeleteTargetDialog({
    isOpen,
    onClose,
    onDelete,
    targetNumber,
    phoneNumber
}: DeleteTargetDialogProps) {
    return (
        <AlertDialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>Weiterleitungsziel löschen?</AlertDialogTitle>
                    <AlertDialogDescription>
                        Möchten Sie das Weiterleitungsziel {targetNumber && `"${targetNumber}"`}
                        {phoneNumber && ` (${phoneNumber})`} wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel onClick={onClose}>Abbrechen</AlertDialogCancel>
                    <AlertDialogAction
                        onClick={onDelete}
                        className="bg-red-500 hover:bg-red-600"
                    >
                        Löschen
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}
